import { configureStore } from "@reduxjs/toolkit";
import comercialStructureReducer from "./reducers/comercialStructure";
import favoritosMenuReducer from "./reducers/favoritosMenuReducer";
import criarVitrineReducer from "./reducers/criarVitrineReducer";

export default configureStore({
  reducer: {
    comercialStructure: comercialStructureReducer,
    favoritosMenu: favoritosMenuReducer,
    criarVitrine: criarVitrineReducer,
  },
});
